import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";
import { LOGO_URL, SOCIALS } from "@/i18n";

const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  const copyright = t.footer.copyright.replace("{year}", String(year));

  return (
    <footer
      id="contact"
      className="relative px-6 md:px-10 pt-24 md:pt-32 pb-10 border-t border-white/10 bg-[#070707] overflow-hidden"
      data-testid="footer-section"
    >
      <div className="glow-blob bg-[#ccff00]" style={{ bottom: "-100px", left: "-80px", width: 380, height: 380, opacity: 0.25 }} />
      <div className="glow-blob bg-[#ff4500]" style={{ top: "20%", right: "-80px", width: 320, height: 320, opacity: 0.25 }} />

      <div className="relative z-10 max-w-[1500px] mx-auto">
        <div className="text-xs uppercase tracking-[0.3em] text-[#ccff00] mb-6">
          {t.sectionLabels.contact}
        </div>
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="font-display text-[18vw] md:text-[14vw] lg:text-[13vw] leading-[0.85] whitespace-pre-line"
          data-testid="footer-big-text"
        >
          {t.footer.bigText.split("\n").map((part, i) => (
            <span key={i} className="block">
              {i === 1 ? <span className="text-[#ccff00]">{part}</span> : part}
            </span>
          ))}
        </motion.h2>

        <div className="mt-12 grid md:grid-cols-[1fr,auto] gap-8 items-end">
          <p className="text-white/60 max-w-xl text-base md:text-lg leading-relaxed">
            {t.footer.sub}
          </p>
          <div className="flex flex-wrap gap-3">
            <a
              href={SOCIALS.threads}
              target="_blank"
              rel="noopener noreferrer"
              className="pill pill-primary"
              data-testid="social-threads"
            >
              {t.footer.threads}
              <ArrowUpRight size={18} />
            </a>
            <a
              href={SOCIALS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="pill pill-ghost"
              data-testid="social-instagram"
            >
              {t.footer.instagram}
              <ArrowUpRight size={18} />
            </a>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            {/* <img src={LOGO_URL} alt="Dhon Studio" className="h-10 w-10 object-contain" /> */}
            <div>
              <div className="font-display text-lg leading-none"></div>
              {/* <div className="text-xs text-white/40 mt-1">{t.footer.crafted}</div> */}
            </div>
          </div>
          <div className="text-sm text-white/40" data-testid="footer-copyright">
            {copyright}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
